function startOfDay(value) {
  const date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function isInThisWeek(dateValue) {
  if (!dateValue) return false;
  const date = startOfDay(dateValue);
  const today = startOfDay(new Date());
  const weekday = today.getDay();
  const mondayOffset = weekday === 0 ? -6 : 1 - weekday;
  const weekStart = new Date(today);
  weekStart.setDate(today.getDate() + mondayOffset);
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  return date >= weekStart && date <= weekEnd;
}

export function isInThisMonth(dateValue) {
  if (!dateValue) return false;
  const date = new Date(dateValue);
  const today = new Date();
  return date.getFullYear() === today.getFullYear()
    && date.getMonth() === today.getMonth();
}

export function isInNext30Days(dateValue) {
  if (!dateValue) return false;
  const date = startOfDay(dateValue);
  const today = startOfDay(new Date());
  const end = new Date(today);
  end.setDate(today.getDate() + 30);
  return date >= today && date <= end;
}

export function filterCommitmentsByZeitraum(commitments, zeitraum) {
  if (!zeitraum || zeitraum === 'all') {
    return commitments;
  }
  return commitments.filter((commitment) => {
    if (zeitraum === 'thisWeek') return isInThisWeek(commitment.dueDate);
    if (zeitraum === 'thisMonth') return isInThisMonth(commitment.dueDate);
    if (zeitraum === 'next30Days') return isInNext30Days(commitment.dueDate);
    return true;
  });
}

export function filterCommitmentsByMilestone(commitments, milestoneId) {
  if (!milestoneId || milestoneId === 'all') {
    return commitments;
  }
  return commitments.filter(
    (commitment) => String(commitment.milestoneId) === String(milestoneId),
  );
}
